import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      {/* Upper Section */}
      <div className="w-full px-6 md:px-10 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-0">
          {/* Left: Brand */}
          <div className="lg:w-[35%]">
            <div className="flex items-center gap-2 mb-8">
              <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-store-2-line text-white text-base"></i>
              </div>
              <span className="text-2xl font-bold font-heading">ACBuy</span>
            </div>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-sm mb-8">
              The ACBuy spreadsheet is a data-driven product discovery system designed to help users find better deals,
              compare prices, and track trending items in one centralized place.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-400 flex items-center justify-center hover:border-primary-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-400 flex items-center justify-center hover:border-primary-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-400 flex items-center justify-center hover:border-primary-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-pinterest-line text-sm"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-400 flex items-center justify-center hover:border-primary-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Middle: Quick Links */}
          <div className="lg:w-[40%]">
            <div className="grid grid-cols-2 gap-8">
              <div>
                <h4 className="text-xs font-semibold tracking-widest text-foreground-400 mb-5 uppercase">Quick Links</h4>
                <div className="space-y-2.5">
                  {categories.slice(0, 7).map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>
              <div>
                <h4 className="text-xs font-semibold tracking-widest text-foreground-400 mb-5 uppercase">More Categories</h4>
                <div className="space-y-2.5">
                  {categories.slice(7).map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-8 mt-8">
              <div>
                <h4 className="text-xs font-semibold tracking-widest text-foreground-400 mb-5 uppercase">Contact</h4>
                <p className="text-sm text-foreground-300">support@acbuy.my</p>
              </div>
              <div>
                <h4 className="text-xs font-semibold tracking-widest text-foreground-400 mb-5 uppercase">Main Site</h4>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-primary-400 hover:text-primary-300 transition-colors duration-150 whitespace-nowrap"
                >
                  kaspreadsheet.com <i className="ri-arrow-right-up-line text-xs"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Right: Featured Image */}
          <div className="lg:w-[25%] flex justify-end">
            <div className="w-48 h-64 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimal%20product%20display%20with%20handcrafted%20ceramic%20vessel%20and%20linen%20textile%20on%20warm%20wooden%20surface%2C%20soft%20afternoon%20sunlight%2C%20artisan%20editorial%20photography%2C%20natural%20earthy%20color%20palette%2C%20organic%20textures%2C%20sophisticated%20minimal%20composition&width=600&height=800&seq=footer-featured-v2&orientation=portrait"
                alt="ACBuy Spreadsheet featured products"
                title="ACBuy Spreadsheet featured products"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-foreground-800/50"></div>

      {/* Bottom Bar */}
      <div className="w-full px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-foreground-400">
          &copy; {new Date().getFullYear()} ACBuy.my Spreadsheet. All rights reserved.
        </p>
        <div className="flex items-center gap-6">
          <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap">Privacy</a>
          <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap">Terms</a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-150 whitespace-nowrap"
          >
            Main Website
          </a>
        </div>
      </div>
    </footer>
  );
}